var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.getUiString(['my_account', 'contact_overview', 'label_emailaddress']))+" ")]),_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.account.EMailAddress)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }